import { Calls } from '@/features/buzz/components/Calls'
import { Page } from '@/ui-kit'

export const CallsPage = () => (
  <Page>
    <Calls />
  </Page>
)

export default CallsPage
